module.exports = __webpack_public_path__ + "static/img/kgu.ca7e360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kgu.png
// module id = Hyib
// module chunks = 17